module.exports = __webpack_public_path__ + "static/media/safety.b1cca3c5.svg";